import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import type { EnrollmentStatus } from '../../../types/enrollment';

const STATUS_MAP: Record<
  EnrollmentStatus,
  'positive' | 'helper' | 'negative' | 'default' | 'highlight'
> = {
  // In Progress (orange/helper)
  payment_selection: 'helper',
  payment_pending: 'helper',
  approval_pending: 'helper',
  approved: 'positive',
  activating: 'positive',
  active: 'positive',
  // Finished (blue/highlight)
  finished: 'highlight',
  finished_with_certificate: 'highlight',
  finished_with_monograph: 'highlight',
  finished_with_pendencies: 'highlight',
  // Denied (red/negative)
  rejected: 'negative',
  canceled: 'negative',
  canceled_in_registration: 'negative',
  blocked: 'negative',
  // Transferred (default/gray)
  transferred: 'default',
  transferred_in_registration: 'default',
};

interface EnrollmentStatusBadgeProps {
  readonly status: EnrollmentStatus;
}

export function EnrollmentStatusBadge({ status }: EnrollmentStatusBadgeProps) {
  const { t } = useTranslation('personManagement');
  return (
    <Tag
      label={t(`enrollmentStatus.${status}`)}
      size="md"
      status={STATUS_MAP[status]}
      custom={{ text: 'text-nowrap' }}
    />
  );
}
